@import '../../style/globals.scss';

.Sidebar {
    transition: transform-origin 500ms $animation-bounce;
}
